// Import reducers
import authReducer from 'features/Auth/authSlice';
import feReducer from 'features/FE/feSlice';
import agencyTransactionReducer from 'features/ManageAgencyTransaction/agencyTransactionSlice';
import commissionTransactionReducer from 'features/ManageCommissionTransaction/commissionTransactionSlice';
import agencyReducer from 'features/ManageDealer/agencySlice';
import investorReducer from 'features/ManageInvestor/investorSlice';
import landownerReducer from 'features/ManageLandowner/landownerSlice';
import paymentTransactionReducer from 'features/ManagePaymentTransactions/paymentTransactionSlice';
import appReducer from './appSlice';

const { configureStore } = require('@reduxjs/toolkit');

// root reducer
const rootReducer = {
  app: appReducer,
  auth: authReducer,
  paymentTransaction: paymentTransactionReducer,
  agency: agencyReducer,
  landowner: landownerReducer,
  fe: feReducer,
  investor: investorReducer,
  commissionTransaction: commissionTransactionReducer,
  agencyTransaction: agencyTransactionReducer,
};

// app store
const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.REACT_APP_DEV_TOOLS_ENABLE == 1 ? true : false,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Vô hiệu hóa serializableCheck
    }),
});

export default store;
